import { render, staticRenderFns } from "./ShipCategoryGatherers.vue?vue&type=template&id=57d7a77c&scoped=true&"
import script from "./ShipCategoryGatherers.vue?vue&type=script&lang=js&"
export * from "./ShipCategoryGatherers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7a77c",
  null
  
)

export default component.exports